import {GradeRange} from '@esgi/main/kits/reports';
import {SubjectLevel, SubjectType} from '@esgi/main/features/teacher/flashcards';

export const studentImageMock = 'https://img.freepik.com/free-photo/education-students-happy-asian-woman-holding-notebooks-laughing-smiling-camera-enjoys-goi_1258-167321.jpg?w=1060&t=st=1707910539~exp=1707911139~hmac=80f785f3b5cb901f396b554bb37baf1134b605d84a15c33ade5a2e7e8d41fe41';

export const parentLetterSettingsMock = {
	includeSkippedQuestions: true,
	showSummary: false,
	showSessionDate: true,
	showNotes: false,
	includeGrades: false,
	includeParentMessage: true,
};

export const subjectsMock = [
	{
		'id': 9567022,
		'name': 'Pre-Reading',
		'type': SubjectType.Personal,
		'hidden': false,
		'level': SubjectLevel.Teacher,
		'testsCount': 122,
		'gradeLevels': null,
		'canEdit': true,
	},
	{
		'id': 9567004,
		'name': 'Pre-Math',
		'type': SubjectType.Personal,
		'hidden': false,
		'level': SubjectLevel.Teacher,
		'testsCount': 132,
		'gradeLevels': null,
		'canEdit': true,
	},
	{
		'id': 9567019,
		'name': 'Music',
		'type': SubjectType.Personal,
		'hidden': false,
		'level': SubjectLevel.Teacher,
		'testsCount': 24,
		'gradeLevels': null,
		'canEdit': true,
	},
	{
		'id': 9567008,
		'name': 'Phonics',
		'type': SubjectType.Personal,
		'hidden': false,
		'level': SubjectLevel.Teacher,
		'testsCount': 55,
		'gradeLevels': null,
		'canEdit': true,
	},
	{
		'id': 9567002,
		'name': 'Sight Words Gr.2',
		'type': SubjectType.Personal,
		'hidden': false,
		'level': SubjectLevel.Teacher,
		'testsCount': 8,
		'gradeLevels': null,
		'canEdit': true,
	},
	{
		'id': 10840458,
		'name': 'Subject1',
		'type': SubjectType.Personal,
		'hidden': false,
		'level': SubjectLevel.Teacher,
		'testsCount': 0,
		'gradeLevels': null,
		'canEdit': true,
	},
	{
		'id': 10840637,
		'name': 'test',
		'type': SubjectType.Personal,
		'hidden': false,
		'level': SubjectLevel.Teacher,
		'testsCount': 0,
		'gradeLevels': null,
		'canEdit': true,
	},
	{
		'id': 10840883,
		'name': 'asdasd',
		'type': SubjectType.Personal,
		'hidden': false,
		'level': SubjectLevel.Teacher,
		'testsCount': 0,
		'gradeLevels': null,
		'canEdit': true,
	},
	{
		'id': 10840884,
		'name': 'subjCT',
		'type': SubjectType.Personal,
		'hidden': false,
		'level': SubjectLevel.Teacher,
		'testsCount': 3,
		'gradeLevels': null,
		'canEdit': true,
	},
];

export const studentsMock = [
	{
		id: 12124545,
		firstName: 'John',
		lastName: 'Smith',
		gradeLevelID: 0,
		photoUrl: studentImageMock,
		hasCredentials: false,
		languageID: 0,
	},
];

export const sessionsMock = [
	{
		'id': 266130292,
		correct: 5,
		incorrect: 6,
		untested: 10,
		'duration': 3832,
		'testDate': '2024-02-15T00:46:04.997',
		'sessionType': 'TestAll',
		'isDeleted': false,
		'notes': null,
		'answers': [
			{
				'questionID': 9958003,
				'answerState': 'Correct',
				'comment': null,
			},
			{
				'questionID': 9958004,
				'answerState': 'Correct',
				'comment': null,
			},
			{
				'questionID': 9958005,
				'answerState': 'Incorrect',
				'comment': null,
			},
			{
				'questionID': 9958006,
				'answerState': 'Correct',
				'comment': null,
			},
			{
				'questionID': 9958007,
				'answerState': 'Correct',
				'comment': null,
			},
		],
		'rubricAnswers': [],
	},
	{
		'id': 266130293,
		correct: 1,
		incorrect: 5,
		untested: 2,
		'duration': 3492,
		'testDate': '2023-02-16T00:46:16.373',
		'sessionType': 'TestAll',
		'isDeleted': false,
		'notes': null,
		'answers': [
			{
				'questionID': 9958006,
				'answerState': 'Incorrect',
				'comment': null,
			},
			{
				'questionID': 9958004,
				'answerState': 'Incorrect',
				'comment': null,
			},
			{
				'questionID': 9958007,
				'answerState': 'Correct',
				'comment': null,
			},
			{
				'questionID': 9958003,
				'answerState': 'Correct',
				'comment': null,
			},
			{
				'questionID': 9958005,
				'answerState': 'Incorrect',
				'comment': null,
			},
		],
		'rubricAnswers': [],
	},
	{
		'id': 266130294,
		correct: 1,
		incorrect: 9,
		untested: 10,
		'duration': 4480,
		'testDate': '2022-03-15T00:49:00.55',
		'sessionType': 'TestAll',
		'isDeleted': false,
		'notes': null,
		'answers': [
			{
				'questionID': 9958006,
				'answerState': 'Correct',
				'comment': null,
			},
			{
				'questionID': 9958003,
				'answerState': 'Correct',
				'comment': null,
			},
			{
				'questionID': 9958007,
				'answerState': 'Correct',
				'comment': null,
			},
			{
				'questionID': 9958004,
				'answerState': 'Correct',
				'comment': null,
			},
			{
				'questionID': 9958005,
				'answerState': 'Correct',
				'comment': null,
			},
		],
		'rubricAnswers': [],
	},
	{
		'id': 266130295,
		correct: 1,
		incorrect: 7,
		untested: 10,
		'duration': 3033,
		'testDate': '2024-02-15T00:46:38.783',
		'sessionType': 'TestAll',
		'isDeleted': false,
		'notes': null,
		'answers': [
			{
				'questionID': 9958006,
				'answerState': 'Correct',
				'comment': null,
			},
			{
				'questionID': 9958003,
				'answerState': 'Incorrect',
				'comment': null,
			},
			{
				'questionID': 9958007,
				'answerState': 'Correct',
				'comment': null,
			},
			{
				'questionID': 9958005,
				'answerState': 'Incorrect',
				'comment': null,
			},
			{
				'questionID': 9958004,
				'answerState': 'Correct',
				'comment': null,
			},
		],
		'rubricAnswers': [],
	},
];

export const gradeRangesMock: GradeRange[] = [
	{
		label: 'WOW',
		from: 90,
		to: 100,
		color: 'indigo64',
		labelColor: 'indigo88',
	},
	{
		label: 'F',
		from: 90,
		to: 100,
		color: 'green48',
		labelColor: 'green96',
	},
	{
		label: 'G',
		from: 90,
		to: 100,
		color: 'primary48',
		labelColor: 'primary96',
	},
	{
		label: 'OK',
		from: 90,
		to: 100,
		color: 'orange56',
		labelColor: 'orange96',
	},
	{
		label: 'ATR',
		from: 90,
		to: 100,
		color: 'red48',
		labelColor: 'red96',
	},
];
